module.exports = __webpack_public_path__ + "img/1a.37792b7a.png";